import { graphql } from "@apollo/client/react/hoc";
import gql from "graphql-tag";
import format from "date-fns/format";

import React from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import Link from "core/Link";
import { apolloClient } from "../apollo/apollo-client";
import DownloadIconLink from "./DownloadIconLink";
import DownloadPhotoLink from "./DownloadPhotoLink";
import { UploadLicense } from "js/graphql";
import * as actions from "../actions/actions";
import Loading from "./loading";
import numberWithCommas from "../legacy/helpers/number_with_commas";

const ITEMS_PER_PAGE = 100;

class DownloadHistory extends React.Component {
    constructor(props) {
        super(props);
        this.props.getCurrentUser();

        this.offset = 0;

        this.state = {
            previousDisabled: true,
            nextDisabled: false,
            showDownloadId: null,
        };
    }

    componentDidMount() {
        window.addEventListener("mousedown", this.pageClick.bind(this), false);
    }

    downloadType(download) {
        let licenseImage = (
            <a
                href={`/${this.props.username}/settings/icon-history/${download.id}`}
                title={"View License PDF"}
                target="_blank"
            >
                <img
                    src={require("../../img/features/icon_history/license.png")}
                    style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "8px",
                    }}
                />
            </a>
        );

        let downloadType;
        switch (download.downloadType) {
            case "PUBLICDOMAIN": // photos
            case "public domain": // icons
                downloadType = <span>Public Domain</span>;
                break;
            case "attribution":
            case "attribution-figma":
                downloadType = <span>None, must attribute</span>;
                break;
            case "prepaid":
                downloadType = <span>Via Prepaid Purchase</span>;
                break;
            case "purchase":
                downloadType = (
                    <span style={{ display: "flex", alignItems: "center" }}>
                        {licenseImage}
                        Via A-La-Carte Purchase
                    </span>
                );
                break;
            case "FREE":
                downloadType = <span>None, must attribute</span>;
                break;
            case "PREMIUM_PHOTO":
                downloadType = <span>Via Premium purchase</span>;
                break;
            case "STANDARD_PHOTO":
                downloadType = <span>Via Standard purchase</span>;
                break;
            // large/full res photo downloads existed in the old pricing model,
            // prior to moving to the "premium" photos model
            case "LARGE":
            case "FULL_RES":
                downloadType = <span>Via A-La-Carte Purchase</span>;
                break;
            default:
                // premium, adobe_plugin, office_plugin, gsuite_plugin, macapp
                // check to see if license is PD which is license 2
                if (
                    download.icon &&
                    download.icon.license == UploadLicense.Publicdomain
                ) {
                    downloadType = <span>Public Domain</span>;
                } else {
                    downloadType = (
                        <span style={{ display: "flex", alignItems: "center" }}>
                            {licenseImage}
                            Via Subscription
                        </span>
                    );
                }
                break;
        }

        return downloadType;
    }

    goToPage(page, e) {
        e.preventDefault();
        this.offset = (page - 1) * 100;
        this.props.loadMoreDownloads(this.offset);
    }

    pageClick(e) {
        if (e.target.parentNode && e.target.parentNode.className === "view-more-link") {
            this.setState({
                showDownloadId: e.target.getAttribute("data-download"),
            });
        } else if (document.querySelector(".action-menu") !== null) {
            if (document.querySelector(".action-menu").contains(e.target) == false) {
                this.setState({ showDownloadId: null });
            }
        }
    }

    purchaseIcon(e) {
        e.preventDefault();
    }

    render() {
        if (this.props.downloadHistory && this.props.user !== undefined) {
            let downloads = this.renderDownloads(),
                nounProAdvert = this.renderNounProAdvert(),
                pagination = this.renderPagination();

            return (
                <section>
                    {nounProAdvert}
                    <h3 className="font-xlarge weight-light margin-t-xl">
                        Download History
                    </h3>
                    <p>Every time you use an image, it is recorded in this list.</p>
                    <table className="billing-history-table">
                        <tbody>
                            <tr className="header-row row">
                                <th className="col-xs-3">Date of use</th>
                                <th className="col-xs-4">Image used</th>
                                <th className="col-xs-4">Royalty—free License</th>
                                <th className="col-xs-1" />
                            </tr>
                            {downloads}
                        </tbody>
                    </table>
                    {pagination}
                </section>
            );
        } else {
            return <Loading />;
        }
    }
    renderNounProAdvert() {
        let advert;
        const eligibleForCreatorPro = this.props.user?.is_eligible_for_creator_pro;
        const hasCreatorPro = this.props.user?.has_creator_pro_account;
        const hasTeam = this.props.user?.teams?.length > 0;
        const showUpgradeCta = !hasCreatorPro && !hasTeam && eligibleForCreatorPro;

        if (this.props.user.has_premium_account === false) {
            advert = (
                <div
                    className="row margin-b-xl padding-b-xl padding-t-l"
                    style={{ borderBottom: "1px solid #BABABA" }}
                >
                    <div className="col-xs-7">
                        <h3 className="font-xlarge weight-medium">
                            Get unlimited, royalty-free icons & photos
                        </h3>
                    </div>
                    <div className="col-xs-4 col-xs-offset-1 margin-t-s">
                        <a href="/pricing/" className="button blue small font-small">
                            <span>See Unlimited Plans</span>
                        </a>
                    </div>
                </div>
            );
        } else if (showUpgradeCta) {
            advert = (
                <div
                    className="row margin-b-xl padding-b-xl padding-t-l"
                    style={{ borderBottom: "1px solid #BABABA" }}
                >
                    <div className="col-xs-7">
                        <h3 className="font-xlarge weight-medium">
                            Upgrade to Creator Pro for royalty-free icon sets & photos
                        </h3>
                        <div className="margin-t-m font-medium">
                            <Link
                                href="/pricing/"
                                title="Noun Project Pricing"
                                styleType="primary"
                                size="md"
                                display="inline"
                            >
                                Learn more
                            </Link>
                        </div>
                    </div>
                    <div className="col-xs-4 col-xs-offset-1 margin-t-l">
                        <a
                            href="/checkout/subscription/individual/payment/cpro-yearly/"
                            className="button blue small font-small"
                        >
                            <span>Upgrade Now</span>
                        </a>
                    </div>
                </div>
            );
        }

        return advert || null;
    }

    renderPhotoActionMenu(download) {
        let actionMenu;
        if (download.photo.active) {
            const photo = download.photo;
            const { license } = photo;

            // public domain & attribution downloads are free, all others are paid
            const downloadTier =
                download.downloadType === "FREE" || license === "PUBLICDOMAIN"
                    ? "FREE"
                    : "PAID";

            actionMenu = (
                <ul className="action-menu">
                    <li>
                        <a
                            href={`/photo/${download.photo.slugWithId}/`}
                            title={"View Photo"}
                            target="_blank"
                        >
                            View Photo
                        </a>
                    </li>
                    {downloadTier === "PAID" ? (
                        <li>
                            <a
                                href={`/${this.props.username}/settings/invoices/`}
                                title={"View Invoices"}
                                target="_blank"
                            >
                                View Invoices
                            </a>
                        </li>
                    ) : (
                        <li>
                            <a
                                href={`https://help.thenounproject.com/hc/en-us/articles/360053641314-How-do-I-credit-a-photographer`}
                                title={"How to Attribute"}
                                target="_blank"
                            >
                                How to Attribute
                            </a>
                        </li>
                    )}
                    <li>
                        <DownloadPhotoLink
                            downloadTier={downloadTier}
                            photoId={download.photo.id}
                        />
                    </li>
                </ul>
            );
        }
        return actionMenu;
    }

    renderIconActionMenu(download) {
        let actionMenu;
        switch (download.downloadType) {
            case "public domain":
                if (download.icon.isActive) {
                    actionMenu = (
                        <ul className="action-menu">
                            <li>
                                <a
                                    href={`/icon/${download.icon.id}/`}
                                    title={"View Icon"}
                                    target="_blank"
                                >
                                    View Icon
                                </a>
                            </li>
                            <li>
                                <DownloadIconLink
                                    type="PNG"
                                    iconId={download.icon.id}
                                    isPro={this.props.user.has_premium_account}
                                />
                            </li>
                            <li>
                                <DownloadIconLink type="SVG" iconId={download.icon.id} />
                            </li>
                        </ul>
                    );
                }
                break;
            case "attribution":
            case "attribution-figma":
                let purchaseIconLink;

                if (this.props.user.has_premium_account === false) {
                    purchaseIconLink = (
                        <li>
                            <a
                                href={`/icon/${download.icon.id}/?purchase=true`}
                                title={"Purchase License"}
                                target="_blank"
                            >
                                Purchase License
                            </a>
                        </li>
                    );
                }
                if (download.icon.isActive) {
                    actionMenu = (
                        <ul className="action-menu">
                            <li>
                                <a
                                    href={
                                        "https://help.thenounproject.com/hc/en-us/articles/200509928-How-do-I-give-creators-credit-in-my-work"
                                    }
                                    title={"How to Attribute"}
                                    target="_blank"
                                >
                                    How to Attribute
                                </a>
                            </li>
                            {purchaseIconLink}
                            <li>
                                <a
                                    href={`/icon/${download.icon.id}/`}
                                    title={"View Icon"}
                                    target="_blank"
                                >
                                    View Icon
                                </a>
                            </li>
                            <li>
                                <DownloadIconLink
                                    type="PNG"
                                    iconId={download.icon.id}
                                    isPro={this.props.user.has_premium_account}
                                />
                            </li>
                            <li>
                                <DownloadIconLink type="SVG" iconId={download.icon.id} />
                            </li>
                        </ul>
                    );
                }
                break;
            case "purchase":
                if (download.icon.isActive) {
                    actionMenu = (
                        <ul className="action-menu">
                            <li>
                                <a
                                    href={`/${this.props.username}/settings/icon-history/${download.id}`}
                                    title={"View License PDF"}
                                    target="_blank"
                                >
                                    View License PDF
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`/${this.props.username}/settings/invoices/`}
                                    title={"View Invoices"}
                                    target="_blank"
                                >
                                    View Invoices
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`/icon/${download.icon.id}/`}
                                    title={"View Icon"}
                                    target="_blank"
                                >
                                    View Icon
                                </a>
                            </li>
                            <li>
                                <DownloadIconLink
                                    type="PNG"
                                    iconId={download.icon.id}
                                    isPro={this.props.user.has_premium_account}
                                />
                            </li>
                            <li>
                                <DownloadIconLink type="SVG" iconId={download.icon.id} />
                            </li>
                        </ul>
                    );
                } else {
                    actionMenu = (
                        <ul className="action-menu">
                            <li>
                                <a
                                    href={`/${this.props.username}/settings/icon-history/${download.id}`}
                                    title={"View License PDF"}
                                    target="_blank"
                                >
                                    View License PDF
                                </a>
                            </li>
                        </ul>
                    );
                }
                break;
            default:
                let licenseLink;

                if (download?.icon?.license !== UploadLicense.Publicdomain) {
                    licenseLink = (
                        <li>
                            <a
                                href={`/${this.props.username}/settings/icon-history/${download.id}`}
                                title={"View License PDF"}
                                target="_blank"
                            >
                                View License PDF
                            </a>
                        </li>
                    );
                }

                if (download.icon.isActive) {
                    actionMenu = (
                        <ul className="action-menu">
                            {licenseLink}
                            <li>
                                <a
                                    href={`/icon/${download.icon.id}/`}
                                    title={"View Icon"}
                                    target="_blank"
                                >
                                    View Icon
                                </a>
                            </li>
                            <li>
                                <DownloadIconLink
                                    type="PNG"
                                    iconId={download.icon.id}
                                    isPro={this.props.user.has_premium_account}
                                />
                            </li>
                            <li>
                                <DownloadIconLink type="SVG" iconId={download.icon.id} />
                            </li>
                        </ul>
                    );
                } else {
                    actionMenu = <ul className="action-menu">{licenseLink}</ul>;
                }
                break;
        }

        return actionMenu;
    }

    renderActionMenu(download) {
        let actionMenu = null;
        if (download.id === this.state.showDownloadId) {
            if (download.icon) {
                actionMenu = this.renderIconActionMenu(download);
            } else if (download.photo) {
                actionMenu = this.renderPhotoActionMenu(download);
            } else {
                console.error("Unknown asset type", download);
            }
        }

        return actionMenu;
    }

    renderUseSource(downloadType) {
        let sourceImageUrl, sourceImageTitle;

        const normalizedType =
            downloadType && downloadType.includes("-figma")
                ? "figma_plugin"
                : downloadType;

        switch (normalizedType) {
            case "macapp":
                sourceImageUrl = require("../../img/features/icon_history/use_mac_app.png");
                sourceImageTitle = "via Mac App";
                break;
            case "adobe_plugin":
                sourceImageUrl = require("../../img/features/icon_history/use_creative_cloud.png");
                sourceImageTitle = "via Adobe Add-on";
                break;
            case "office_plugin":
                sourceImageUrl = require("../../img/features/icon_history/use_office.png");
                sourceImageTitle = "via Office Add-in";
                break;
            case "gsuite_plugin":
                sourceImageUrl = require("../../img/features/icon_history/use_google.png");
                sourceImageTitle = "via Google Add-on";
                break;
            case "figma_plugin":
                sourceImageUrl = "/web-images/third-party-logos/figma.svg";
                sourceImageTitle = "via Figma Plugin";
                break;
            default:
                // premium, purchase, public domain, attribution
                sourceImageUrl = require("../../img/features/icon_history/use_download.png");
                sourceImageTitle = "via nounproject.com";
                break;
        }

        let imgHtml = (
            <img
                src={sourceImageUrl}
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
                title={sourceImageTitle}
            />
        );

        return imgHtml;
    }

    renderDownloads() {
        let downloads = [],
            iconLink;

        if (this.props.downloadHistory.items.length > 0) {
            this.props.downloadHistory.items.forEach(download => {
                let actionMenu = this.renderActionMenu(download);

                let nameAndId, isActive, detailPath, thumbnailURL;
                if (download.icon) {
                    nameAndId = `${download.icon.name} #${download.icon.id}`;
                    isActive = download.icon.isActive;
                    detailPath = `/icon/${download.icon.id}/`;
                    thumbnailURL = download.icon.thumbnails.thumbnail200;
                } else if (download.photo) {
                    nameAndId = `${download.photo.title} #${download.photo.id}`;
                    isActive = download.photo.active;
                    detailPath = `/photo/${download.photo.slugWithId}/`;
                    thumbnailURL = require("../../img/features/icon_history/photo.svg");
                } else {
                    return;
                }

                let rowClasses = ["row", "data"];
                if (download.icon !== null || download.photo !== null) {
                    let detailLink;
                    if (isActive) {
                        detailLink = (
                            <span>
                                <Link
                                    href={detailPath}
                                    title={`View ${nameAndId}`}
                                    styleType="primary"
                                    size="md"
                                    display="inline"
                                >
                                    {nameAndId}
                                </Link>
                            </span>
                        );
                    } else {
                        detailLink = (
                            <span title="This icon is no longer available">
                                {nameAndId}
                            </span>
                        );
                    }

                    downloads.push(
                        <tr key={download.id} className={rowClasses.join(" ")}>
                            <td
                                className="col-xs-3"
                                title={format(
                                    new Date(download.downloadDate),
                                    "MMM DD, YYYY hh:mm:ss a",
                                )}
                                style={{ textTransform: "uppercase" }}
                            >
                                {this.renderUseSource(download.downloadType)}
                                {format(new Date(download.downloadDate), "MM/DD/YY")}
                            </td>
                            <td
                                className="col-xs-4 icon-name"
                                style={{ position: "relative" }}
                            >
                                <span className="downloaded-icon-container">
                                    <img
                                        src={thumbnailURL}
                                        style={{
                                            width: "24px",
                                            height: "24px",
                                            marginRight: "10px",
                                            cursor: "zoom",
                                        }}
                                    />
                                    <span className="downloaded-icon-zoom">
                                        <img
                                            src={thumbnailURL}
                                            style={{
                                                width: "200px",
                                                height: "200px",
                                            }}
                                        />
                                    </span>
                                </span>
                                {detailLink}
                            </td>
                            <td className="col-xs-4">{this.downloadType(download)}</td>
                            <td
                                className="col-xs-1 view-more-link"
                                style={{
                                    position: "relative",
                                    textAlign: "right",
                                    cursor: "pointer",
                                }}
                                onClick={this.showActionMenu.bind(this, download.id)}
                            >
                                <span data-download={download.id}>
                                    <span className="ui_more" title="view more" />
                                </span>
                                {actionMenu}
                            </td>
                        </tr>,
                    );
                } else {
                    downloads.push(
                        <tr key={download.id} className={rowClasses.join(" ")}>
                            <td
                                className="col-xs-3"
                                title={format(
                                    new Date(download.downloadDate),
                                    "MMM DD, YYYY",
                                )}
                                style={{ textTransform: "uppercase" }}
                            >
                                {this.renderUseSource(download.downloadType)}
                                {format(new Date(download.downloadDate), "MM/DD/YY")}
                            </td>
                            <td>This icon no longer exists.</td>
                            <td />
                            <td />
                        </tr>,
                    );
                }
            });
        } else {
            downloads.push(
                <tr key="no-results" className="row data">
                    <td>
                        There is nothing to show yet. Every icon you use will show up in
                        this list.
                    </td>
                </tr>,
            );
        }

        return downloads;
    }

    renderPageLinks() {
        let lastPage = Math.ceil(this.props.downloadHistory.totalCount / ITEMS_PER_PAGE),
            pageNumbers = [];

        if (this.props.downloadHistory.totalCount > ITEMS_PER_PAGE) {
            let currentPage = 1,
                page = (this.offset + ITEMS_PER_PAGE) / ITEMS_PER_PAGE,
                maxPages = Math.ceil(
                    this.props.downloadHistory.totalCount / ITEMS_PER_PAGE,
                ),
                totalPages = maxPages;

            if (page <= 6) {
                if (maxPages > 6) {
                    totalPages = 6;
                }

                while (currentPage <= totalPages) {
                    pageNumbers.push(
                        <li key={currentPage}>
                            <a
                                href="#"
                                onClick={this.goToPage.bind(this, currentPage)}
                                className={page === currentPage ? "active" : ""}
                            >
                                {currentPage}
                            </a>
                            {currentPage !== maxPages ? "," : ""}
                        </li>,
                    );
                    currentPage = currentPage + 1;
                }

                if (maxPages > 6) {
                    pageNumbers.push(<li key={8}>{"..."}</li>);
                    pageNumbers.push(
                        <li key={9}>
                            <a
                                href="#"
                                onClick={this.goToPage.bind(this, lastPage)}
                                className={page === lastPage ? "active" : ""}
                            >
                                {lastPage}
                            </a>
                        </li>,
                    );
                }
            } else if (page > lastPage - 6) {
                pageNumbers = [
                    <li key={1}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, 1)}
                            className={page === 1 ? "active" : ""}
                        >
                            1
                        </a>
                        {","}
                    </li>,
                    <li key={2}>{"..."}</li>,
                    <li key={3}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 5)}
                            className={page === lastPage - 5 ? "active" : ""}
                        >
                            {lastPage - 5}
                        </a>
                        {","}
                    </li>,
                    <li key={4}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 4)}
                            className={page === lastPage - 4 ? "active" : ""}
                        >
                            {lastPage - 4}
                        </a>
                        {","}
                    </li>,
                    <li key={5}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 3)}
                            className={page === lastPage - 3 ? "active" : ""}
                        >
                            {lastPage - 3}
                        </a>
                        {","}
                    </li>,
                    <li key={6}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 2)}
                            className={page === lastPage - 2 ? "active" : ""}
                        >
                            {lastPage - 2}
                        </a>
                        {","}
                    </li>,
                    <li key={7}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage - 1)}
                            className={page === lastPage - 1 ? "active" : ""}
                        >
                            {lastPage - 1}
                        </a>
                        {","}
                    </li>,
                    <li key={8}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage)}
                            className={page === lastPage ? "active" : ""}
                        >
                            {lastPage}
                        </a>
                    </li>,
                ];
            } else {
                pageNumbers = [
                    <li key={1}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, 1)}
                            className={page === 1 ? "active" : ""}
                        >
                            1
                        </a>
                        {","}
                    </li>,
                    <li key={2}>{"..."}</li>,
                    <li key={3}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, (this.offset + 100) / 100)}
                            className="active"
                        >
                            {(this.offset + 100) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={4}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, (this.offset + 200) / 100)}
                        >
                            {(this.offset + 200) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={5}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, (this.offset + 300) / 100)}
                        >
                            {(this.offset + 300) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={6}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, (this.offset + 400) / 100)}
                        >
                            {(this.offset + 400) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={7}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, (this.offset + 500) / 100)}
                        >
                            {(this.offset + 500) / 100}
                        </a>
                        {","}
                    </li>,
                    <li key={8}>{"..."}</li>,
                    <li key={9}>
                        <a
                            href="#"
                            onClick={this.goToPage.bind(this, lastPage)}
                            className={page === lastPage ? "active" : ""}
                        >
                            {lastPage}
                        </a>
                    </li>,
                ];
            }
        }
        return pageNumbers;
    }

    renderPagination() {
        let page = (this.offset + ITEMS_PER_PAGE) / ITEMS_PER_PAGE,
            pageLinks = this.renderPageLinks(),
            pagination,
            totalPages = Math.ceil(
                this.props.downloadHistory.totalCount / ITEMS_PER_PAGE,
            ),
            totalShowCount = this.renderTotalShowCount();

        if (page <= totalPages) {
            pagination = (
                <div className="table-pagination-container padding-t-xl">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            className={`table-list_arrow left-arrow ui_left-arrow ${
                                page === 1 ? "disabled" : ""
                            }`}
                            onClick={this.showPrevious.bind(this)}
                        />
                        <ul
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "0 20px",
                            }}
                            className="pagination-links"
                        >
                            {pageLinks}
                        </ul>
                        <div
                            className={`table-list_arrow right-arrow ui_right-arrow ${
                                page === totalPages ? "disabled" : ""
                            }`}
                            onClick={this.showNext.bind(this)}
                        />
                    </div>
                    <div
                        className="weight-light"
                        style={{
                            margin: "0 auto",
                            width: "200px",
                            textAlign: "center",
                            color: "#bababa",
                        }}
                    >
                        {totalShowCount}
                    </div>
                </div>
            );
        }

        return pagination;
    }

    showActionMenu(downloadId, e) {
        this.setState({ showDownloadId: downloadId });
    }

    showPrevious() {
        this.offset = this.offset - 100;
        this.props.loadMoreDownloads(this.offset);
    }

    showNext() {
        this.offset = this.offset + 100;
        this.props.loadMoreDownloads(this.offset);
    }

    renderTotalShowCount() {
        let page = (this.offset + ITEMS_PER_PAGE) / ITEMS_PER_PAGE,
            iconsPerPage = this.offset + 100,
            totalCount = this.props.downloadHistory.totalCount,
            totalPages = Math.ceil(
                this.props.downloadHistory.totalCount / ITEMS_PER_PAGE,
            ),
            totalShowCount;

        if (iconsPerPage > 0) {
            iconsPerPage = iconsPerPage - 99;
        }

        totalShowCount = (
            <span>
                Showing {numberWithCommas(iconsPerPage)} -{" "}
                {page === totalPages
                    ? numberWithCommas(totalCount)
                    : numberWithCommas(iconsPerPage + 99)}{" "}
                of {` ${numberWithCommas(totalCount)}`}
            </span>
        );

        return <div style={{ margin: "0 auto", width: "200px" }}>{totalShowCount}</div>;
    }
}

function mapStateToProps(state, ownProps) {
    let creator,
        user = state.user;

    if (state.creator.keys) {
        creator = state.creator[state.creator.keys[0]];
    }

    let { username } = ownProps.match.params;

    return { creator, user, username };
}

function findUsername() {
    // With this old component graphQL code I cant really get this.props.match.username from the DownloadHistory component props
    // Since this code is going to be rewritten anyway I'm just going to extract it from the URL for now
    const url = window.location.href;
    const matchArray =
        url.match(/com\/(.*)\/settings\/icon-history/g) ||
        url.match(/8080\/(.*)\/settings\/icon-history/g);
    return matchArray.length
        ? matchArray[0]
              .replace("com/", "")
              .replace("8080/", "")
              .replace("/settings/icon-history", "")
        : "";
}

const FEED_QUERY = gql`
    query downloadHistory($limit: Int, $offset: Int, $username: String) {
        downloadHistory(limit: $limit, offset: $offset, username: $username) {
            totalCount
            items {
                id
                downloadDate
                downloadType
                icon {
                    isActive
                    id
                    license
                    name: title
                    thumbnails {
                        thumbnail200
                    }
                }
                photo {
                    id
                    slugWithId
                    title
                    active
                    isPremium
                    license
                }
            }
        }
    }
`;

const FeedWithData = graphql(FEED_QUERY, {
    options(props) {
        return {
            variables: {
                offset: 0,
                limit: ITEMS_PER_PAGE,
                username: findUsername(),
            },
            client: apolloClient,
        };
    },
    props({ data: { loading, downloadHistory, currentUser, fetchMore } }) {
        return {
            loading,
            downloadHistory,
            currentUser,
            loadMoreDownloads(offset) {
                return fetchMore({
                    variables: {
                        offset: offset,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            downloadHistory: Object.assign(
                                {},
                                previousResult.downloadHistory,
                                {
                                    items: fetchMoreResult.downloadHistory.items,
                                },
                            ),
                        };
                    },
                });
            },
        };
    },
})(DownloadHistory);

const ConnectedDownloadHistory = connect(mapStateToProps, {
    getCurrentUser: actions.getCurrentUser,
})(FeedWithData);

// Wrapper component to provide route params
const DownloadHistoryWithRouter = () => {
    const params = useParams();
    return <ConnectedDownloadHistory match={{ params }} />;
};

export default DownloadHistoryWithRouter;
